import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CommissionsPage } from '@/pages/commissions';
import { commissionsSearchSchema } from '@/routes/-shared/commissionsSearchSchema';

/**
 * La lista resta montata e il dettaglio della commissione si apre sopra di
 * lei sull'`Outlet` (`$id`), come nella webapp: chiudere il pannello torna
 * alla lista con filtri e scorrimento di prima.
 */
export const Route = createFileRoute('/referrer/_layout/commissions/_layout')({
  component: CommissionsLayout,
  validateSearch: commissionsSearchSchema,
});

function CommissionsLayout() {
  return (
    <>
      <CommissionsPage />
      <Outlet />
    </>
  );
}
